import React from "react"

export default function Home() {
  return <div>Welcome to ComeHarder.com,<br/>Store Coming soon!</div>
}
